/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../helper/URLHelper';

const NotificationsView = () => import('./components/NotificationsView.vue');

// Sem a moldura de Configurações (`SettingsWrapper`) desde 07/10/2026: ela
// punha a página numa caixa cinza deslocada no meio da tela. Notificações é
// tela do dia a dia, não ajuste — usa o chão das outras telas.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/notifications'),
    name: 'notifications_index',
    component: NotificationsView,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
];
